export default __webpack_public_path__ + "./images/bj.cfea350a.png";